const TextError = (props: any) => {
  return <p className="text-accent-secondary font-light pl-4 text-sm mt-2">{props.children}</p>;
};

export default TextError;
